import Vue from 'vue'
import App from './components/App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import SnackbarStack from 'snackbarstack'
import VueGTagPlugin from '/Users/steven/dev/projects/other/quickchords-vue/src/util/VueGtagPlugin.js'

Vue.config.productionTip = false

Vue.use(SnackbarStack)
Vue.use(Vuetify) 
Vue.use(VueGTagPlugin, {enabled: true, debug: false})

new Vue({
  render: h => h(App)
}).$mount('#app')
